import User from './Users';

export default User;
